<template>
<div class="line">
  <div class="border-1px">
  </div>
</div>
</template>
<script>
    export default {
        components: {},
        props: {

        },
        data () {
            return {

            }
        },
        computed: {

        },
        methods: {

        },
        mounted () {}
    }
</script>
<style scoped lang="less">
.line{
  position: relative;
  width: 100%;
  height: 1px;
//   overflow: hidden;
  .border-1px:after {
    position: absolute;
    content: "";
    width: 200%;
    height: 200%;
    top: 0;
    left: 0;
    -webkit-transform-origin: top left;
    -webkit-transform: scale(0.5,0.5);
    transform: scale(0.5,0.5);
    border-top: 1px solid #EEEEEE;
    // z-index: 9999999999999999;
  }
  /* 2倍屏 */
  @media only screen and (-webkit-min-device-pixel-ratio: 2.0) {
      .border-1px:after {
          -webkit-transform: scale(0.5,0.5);
          transform: scale(0.5,0.5);
      }
  }
  /* 3倍屏 */
  @media only screen and (-webkit-min-device-pixel-ratio: 3.0) {
      .border-1px:after {
          -webkit-transform: scale(0.5,0.33);
          transform: scale(0.5,0.33);
      }
  }

}

</style>
